import React from 'react';

interface InfoMessageProps {
	message: string;
}

export const InfoMessage: React.FC<InfoMessageProps> = ({ message }) => {
	if (!message) return null;

	return (
		<div
			className="
        p-4
        mb-4
        border-l-4
        border-blue-400
        bg-gradient-to-r from-blue-50 via-blue-100 to-blue-50
        rounded-md
        shadow-sm
      "
			role="alert"
		>
			<p
				className="
          text-sm
          font-medium
          text-blue-800
        "
			>
				{message}
			</p>
		</div>
	);
};
